/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
import { ref } from "@vue/composition-api";
import { getPlanEmailListApi } from "../apis/email-manage";
import { reverseConstructRichArea } from '../helper/rich-area-helper'
import useEmailState from './use-email-state'

export default function useState() {
  const { insertArguments } = useEmailState();
  const dataSource = ref([]);

  const getTableDataSource = async (val) => {
    const res = await requestPlanEmailList({ mailName: val });
    dataSource.value = res || [];
  };

  const requestPlanEmailList = async (params) => {
    try {
      const res = await getPlanEmailListApi(params);
      const data = res?.records.map((item)=> ({
        ...item,
        mailHeader: reverseConstructRichArea(item.mailHeader, insertArguments)
      }))
      console.log(data)
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    {
      title: "邮件id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "邮件名称",
      dataIndex: "mailName",
      key: "mailName",
    },
    {
      title: "邮件描述",
      dataIndex: "mailDescription",
      key: "mailDescription",
    },
    {
      title: "邮件标题",
      key: "mailHeader",
      scopedSlots: { customRender: "mailHeader" },
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      width: 100,
      scopedSlots: { customRender: "action" },
    },
  ];

  return {
    columns,
    dataSource,
    getTableDataSource,
  };
}
